import { useEffect } from 'react';
import { PageHeader } from '@/components/organisms/PageHeader';
import { logPageView } from '@/services/analytics.service';

export const TermsPage = () => {

  useEffect(() => {
    logPageView('Terms of Service Page');
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PageHeader title="Terms of Service" showBackButton />

      {/* Content */}
      <main className="max-w-[800px] mx-auto px-4 py-12">
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <div className="mb-8">
            <p className="text-muted-foreground text-sm">
              Last updated: {new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              By accessing and using tuval.space, you accept and agree to be bound
              by the terms and provision of this agreement. If you do not agree to
              abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Use License</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Permission is granted to temporarily use tuval.space for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on tuval.space</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. User Accounts</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              When you create an account with us, you must provide information that
              is accurate, complete, and current at all times. You are responsible
              for safeguarding the password and for all activities that occur under
              your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Pixel Placement Rules</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Users are granted a daily quota of pixels that can be placed on
              boards. Unused pixels may accumulate up to a specified limit. You
              agree to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4">
              <li>Respect the daily pixel quota system</li>
              <li>Not attempt to circumvent or manipulate the quota system</li>
              <li>Use pixels in accordance with community guidelines</li>
              <li>Not create offensive, harmful, or illegal content</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. User Content</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              You retain ownership of any content you create on tuval.space. By
              posting content, you grant tuval.space a worldwide, non-exclusive,
              royalty-free license to use, reproduce, and distribute your content
              on the platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Prohibited Uses</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              You may not use tuval.space:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4">
              <li>In any way that violates any applicable law or regulation</li>
              <li>To transmit any malicious code or viruses</li>
              <li>To impersonate or attempt to impersonate another user</li>
              <li>To engage in any automated use of the system</li>
              <li>To interfere with or disrupt the service</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">7. Termination</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We may terminate or suspend your account and access to the service
              immediately, without prior notice, for conduct that we believe
              violates these Terms of Service or is harmful to other users, us, or
              third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">8. Disclaimer</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              The materials on tuval.space are provided on an 'as is' basis.
              tuval.space makes no warranties, expressed or implied, and hereby
              disclaims and negates all other warranties including, without
              limitation, implied warranties or conditions of merchantability,
              fitness for a particular purpose, or non-infringement of intellectual
              property or other violation of rights.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">9. Limitations</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              In no event shall tuval.space or its suppliers be liable for any
              damages (including, without limitation, damages for loss of data or
              profit, or due to business interruption) arising out of the use or
              inability to use the materials on tuval.space.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">10. Changes to Terms</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              tuval.space may revise these terms of service at any time without
              notice. By using this website you are agreeing to be bound by the
              then current version of these terms of service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">11. Contact Information</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              If you have any questions about these Terms of Service, please
              contact us through our platform or visit our GitHub repository.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

